import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import PageTitles from '../page-titles'
import { withRouter } from 'react-router-dom'

import './page-not-found.css'

class PageNotFound extends React.PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			hide: false,
			hidden: false,
		}
	}
	onClick = () => {
		this.setState({
			hide: true
		})
	}
	onTransitionEnd = (e) => {
		if (e.target !== this.ref) { return }
		this.setState({
			hidden: true
		})
		
		this.props.history.push('/')
	}
	render() {
		if (!this.props.active) { return null }
		const className = classnames('page-not-found', 'layer-page--active', {
			'page-not-found--hide': this.state.hide,
		})
		return (
			<div 
				ref={ ref => this.ref = ref }
				className={className}
				onClick={this.onClick}
				onTransitionEnd={this.onTransitionEnd}
			>
				<PageTitles 
					title="Sorry, page not found."
					subtitle="back to home"
				/>
				<div className="overlay-heading" style={{ height: '100vh' }}>
	        <div className="overlay-heading__text--appear overlay-heading__text--appear-no-transition overlay-heading__text text--headline">404</div>
	      </div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	const currentPage = state.app.get('currentPageName')
	return {
		active: !currentPage
	}
}

export default withRouter(
	connect(mapStateToProps)(PageNotFound)
)


// WEBPACK FOOTER //
// ./src/components/page-not-found/index.js